import { ApiError } from '../api/client'

export function toApiMessage(error: unknown, fallback: string): string {
  return error instanceof ApiError ? error.message : fallback
}
